import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import accounting from 'accounting';

import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';

const CustomDonationContainer = styled.form`
    background-color: #f8f8f7;
    flex-direction: column;
    justify-content: space-between;
    padding: 1em;
    display: flex;
    transform: translate3d(0, 0, 0);
    position: relative;
    z-index: 1;

    &.transition-enter {
        transform: translate3d(0, 100%, 0);
        z-index: 10;
        position: relative;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    &.transition-enter.transition-enter-active {
        transition-timing-function: ease-out;
        transform: translate3d(0, 0, 0);
        transition: transform 0.3s;

        @media (max-width: 30em) {
            transition: transform 0.5s;
        }
    }

    &.transition-exit {
        transform: translate3d(0, 0, 0);
        position: relative;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
    }

    &.transition-exit.transition-exit-active {
        transition-timing-function: ease-in;
        transform: translate3d(0, 100%, 0);
        transition: transform 0.3s;

        @media (max-width: 30em) {
            transition: transform 0.8s;
        }
    }
`;

const validate = values => {
    const errors = {};

    const amount = accounting.unformat(values.amount);
    if (amount <= 0) {
        errors.amount = 'Invalid Value';
    } else if (amount < 5) {
        errors.amount = 'Minimum amount is $5';
    } else if (amount > 10000) {
        errors.amount = 'Maximum amount is $10,000';
    }

    return errors;
};

const setCaretPosition = ev => {
    setTimeout(() => {
        var target = ev.target;
        var value = target.value;
        target.selectionStart = target.selectionEnd = value.length;
    }, 50);
};

const CustomDonation = props => (
    <CustomDonationContainer onSubmit={props.handleSubmit}>
        <Field
            name="amount"
            component={InputGroup}
            type="tel"
            normalize={value => accounting.formatMoney(value, '$ ', 0)}
            parse={value => accounting.unformat(value)}
            onChange={ev => setCaretPosition(ev)}
            label="Add custom donation"
            maxLength={8}
            autoFocus={true}
            autoFocusTimeout={700}
            labelBackgroundColor={'#f8f8f7'}
        />
        <TwoGroup marginTop={'1em'}>
            <Button label="Back" onClick={props.onCancelDonateMore} />
            <Button
                primary={true}
                label="Next"
                type="submit"
                disabled={props.invalid || props.submitting}
            />
        </TwoGroup>
    </CustomDonationContainer>
);

CustomDonation.propTypes = {
    onCancelDonateMore: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired
};

export default reduxForm({
    form: 'customDonationForm',
    validate
})(CustomDonation);
